import styled from 'styled-components';
import { getSpacingToken } from '@optimus-web/core';

export const CardDetailListElement = styled.ul`
    flex-grow: 1;
    margin: 0;
    padding: 0;
    & > *:not(:last-child) {
        margin-bottom: ${getSpacingToken('200')}px;
    }
`;

export const CardDetailListItemElement = styled.li`
    display: flex;
    justify-content: space-between;
    list-style-type: none;
`;
